export enum OnBoardingTask {
  DUE = 'onboarding-due',
  CONTRAT = 'onboarding-ancien-contrat',
  DEMO = 'onboarding-demo',
  COLLAB = 'onboarding-collaborateurs'
}
